<template>
<div class="find-password">
   <el-form :label-position="labelPosition" label-width="95px" ref="findPassword" :rules="formRules" :model="findPassword" class="find-password-box">
    <h2>重置密码</h2>
    <el-form-item label="新密码" prop="password">
        <el-input v-model="findPassword.password" type="password"></el-input>
    </el-form-item>
    <el-form-item label="确认密码" prop="password_">
        <el-input v-model="findPassword.password_" type="password" @keyup.enter.native="update"></el-input>
    </el-form-item>
    <el-form-item>
        <el-button size="small" type="primary" class="large-bt" @click="update">重置密码</el-button></el-form-item>
</el-form>
</div>
</template>
<script>
export default {
  data() {
    var confirmPasswordValidator = (rule, value, callback) => {
      if (value !== this.findPassword.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      labelPosition: "right",
      findPassword: {
        password: "",
        password_: ""
      },
      formRules: {
        password: [
          { required: true, message: "请输入新密码", trigger: ["blur"] }
        ],
        password_: [
          { required: true, message: "请再次输入密码", trigger: ["blur"] },
          { validator: confirmPasswordValidator, trigger: ["blur"] }
        ]
      }
    };
  },
  methods: {
    update() {
      this.$refs["findPassword"].validate(valid => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: "密码重置中",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)"
          });
          this.$axios
            .post("/openApi/resetPasswordWithToken", {
                "newPassword": this.findPassword.password,
                "token": this.$route.query.token
            })
            .then(res => {
              loading.close();
              if (res.code === 200) {
                this.$message({
                  message: "密码重置成功",
                  type: "success"
                });
              }
            })
            .catch(err => {
              loading.close();
            })
            .finally(() => {
              loading.close();
            });
        }
      });
    }
  },
  mounted() {
    let winWidth;
    if (window.innerWidth) winWidth = window.innerWidth;
    else if (document.body && document.body.clientWidth)
      winWidth = document.body.clientWidth;
    this.labelPosition = winWidth > 480 ? "right" : "top";
  }
};
</script>


<style scoped>
.large-bt {
  width: 100%;
  font-size: 16px;
  background: #00549f;
}
h2 {
  line-height: 60px;
  color: #333;
}
.find-password-box {
  width: 500px;
  position: absolute;
  top: 20px;
  left: 50%;
  margin-left: -250px;
}
.box-card {
  width: 100%;
  margin-top: 10px;
}
span {
  padding-left: 16px;
  font-size: 14px;
  color: #333;
}
.el-input {
  width: 80%;
}
button {
  float: right;
  margin-left: 20px;
}
@media screen and (max-width: 500px) {
  .el-card {
    box-shadow: none;
    border: none;
  }
  .find-password-box{
    width: 100%;
    margin: 0;
    padding: 24px;
    position: relative;
    top: 0;
    left: 0;
  }
}
</style>
